export default class MaintenanceEnabled extends Error {
  constructor(error) {
    super(error);
    this.name = "MaintenanceEnabled";
    this.description = error?.response?.data.message;
  }
}
